import { computed, reactive } from 'vue';
import axios from 'axios';
import Helper from '@/libraries/Helpers';

const httpInstance = axios.create();

const state = reactive({
  countries: {},
  countryCarriers: {},
  carrierItems: {},
  totalPrice: 0,
  totalPriceWithVat: 0
});

export default function useTransport() {
  const getFilteredCountries = () => {
    return computed(() => state.countries).value;
  };

  const getFilteredCarriers = () => {
    return computed(() => {
      const carriers = state.countryCarriers[state.countries.value];

      if (!carriers) {
        state.totalPrice = 0;
        state.totalPriceWithVat = 0;

        return {
          options: [],
          value: null
        };
      }

      if (carriers.options.length) {
        let findCurrentCarrierIndex = carriers.options.findIndex(
          currentCarrier => currentCarrier.value === carriers.value
        );

        if (findCurrentCarrierIndex === -1) {
          findCurrentCarrierIndex = 0;
          carriers.value = carriers.options[findCurrentCarrierIndex].value;
        }

        const activeCarrier = carriers.options[findCurrentCarrierIndex];
        state.totalPrice = activeCarrier.totalPrice;
        state.totalPriceWithVat = activeCarrier.totalPriceWithVat;
      }

      return carriers;
    }).value;
  };

  const getFilteredCarrierItems = () => {
    return computed(() => {
      const carriersItems =
        state.carrierItems[state.countryCarriers[state.countries.value].value];

      if (!carriersItems) {
        return {
          options: [],
          value: null
        };
      }

      return carriersItems;
    }).value;
  };

  const setTransport = transport => {
    const transportEntries = Object.entries(transport);
    const collectCountries = [];
    let selectedCountryId = null;
    for (const [countryId, country] of transportEntries) {
      const collectCarrierOptions = [];
      let selectedCarrierId = null;
      const countryCarrierEntries = Object.entries(country.carriers);
      for (const [carrierId, carrier] of countryCarrierEntries) {
        if (carrier.options) {
          const collectCarrierOptions = [];
          let selectedCarrierOption = null;
          const countryCarrierOptionsEntries = Object.entries(carrier.options);
          for (const [
            carrierOptionId,
            carrierOption
          ] of countryCarrierOptionsEntries) {
            const collectOptions = [];
            const carrierOptionEntries = Object.entries(carrierOption.items);
            for (const [optionItemId, optionItem] of carrierOptionEntries) {
              collectOptions.push({
                value: optionItemId,
                label: optionItem.name
              });
              if (optionItem.selected) {
                selectedCarrierOption = optionItemId;
              }
            }
            collectCarrierOptions.push({
              value: carrierOptionId,
              label: carrierOption.groupName,
              options: collectOptions
            });
          }

          state.carrierItems[carrier.uID] = {
            options: collectCarrierOptions,
            value: selectedCarrierOption
          };
        }

        const totalPrice = carrier.price;
        const totalPriceWithVat = Helper.vatPrice(carrier.price, carrier.vat);

        collectCarrierOptions.push({
          ...carrier,
          id: carrierId,
          value: carrier.uID,
          label: carrier.name,
          totalPrice,
          totalPriceWithVat
        });
        if (carrier.selected) {
          selectedCarrierId = carrier.uID;
        }
      }

      state.countryCarriers[countryId] = {
        options: collectCarrierOptions,
        value: selectedCarrierId
      };

      collectCountries.push({
        value: countryId,
        label: country.name
      });
      if (country.selected) {
        selectedCountryId = countryId;
      }
    }
    state.countries = {
      options: collectCountries,
      value: selectedCountryId
    };
  };

  const getTotalPrice = () => {
    return state.totalPrice;
  };

  const getTotalPriceWithVat = () => {
    return state.totalPriceWithVat;
  };

  const saveTransport = async () => {
    const uID = state.countryCarriers[state.countries.value].value || null;
    const value = state.carrierItems[uID]
      ? state.carrierItems[uID].value
      : null;
    try {
      await httpInstance.post('get/api/shopBasket/transport', {
        uID,
        value
      });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    getFilteredCountries,
    getFilteredCarriers,
    getFilteredCarrierItems,
    setTransport,
    getTotalPrice,
    getTotalPriceWithVat,
    saveTransport
  };
}
